import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import SectionTitle from "../../../components/sectionTitle";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Box, Typography } from "@mui/material";
import { getRoute } from "../../../helpers/utils";
import { useHistory } from "react-router";

function BuyflowApplicationSubmission({
  classes: { borderContainter, container, main },
}) {
  const history = useHistory();
  const [isProcessed, setIsProcessed] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsProcessed(true);
    }, 5000);
  }, []);

  useEffect(() => {
    if (isProcessed) {
      navigateTo(getRoute("instaConfirmation"));
    }
  }, [isProcessed]);

  const navigateTo = (pathname) => history.push({ pathname });

  return (
    <Box className={main}>
      <Box display="flex" justifyContent="center" mt={5}>
        <SectionTitle title={"Application Submission"} hideBack={true} />
      </Box>

      <Box flexDirection="column" mt={5}>
        <Box mt={3} p={1} pb={2}>
          <CircularProgress />
        </Box>
        <Typography variant="caption">
          Your application submission is in progress. Please wait for a few
          seconds.
        </Typography>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  BuyflowApplicationSubmission
);
